<template>
  <v-col class="shrink app-sidebar app-sidebar-left">
    <SearchForm v-if="!$store.state.showArticleOnly" />
    <!-- Banners v-if="!['homewlang', 'home'].includes($route.name)" / -->
    <ContactBannerNew />
    <MainShare />
    <DynamicAutoHeightInfoBox
      v-if="['homewlang', 'home'].includes($route.name) || !!$route.name"
      :show-indexes="
        ['homewlang', 'home'].includes($route.name)
          ? [1, 2, 3, 4, 5, 6, 7]
          : [1, 3]
      "
    />
  </v-col>
</template>

<script>
import SearchForm from '@/components/Forms/SearchForm'
import FacebookFrame from '@/components/App/Extras/_FacebookFrame'
import MainShare from '@/components/App/Extras/_MainShare'
import Banners from '@/components/App/Extras/_Banners'
import ContactBanner from '@/components/App/Extras/_ContactBanner'
import DynamicAutoHeightInfoBox from '@/components/App/DynamicAutoHeightInfoBox'
import sharedComputed from '@/methods/sharedComputed'
import ContactBannerNew from '@/components/App/Extras/ContactBannerNew.vue'

export default {
  name: 'DesktopLeftSidebar',

  components: {
    ContactBannerNew,
    DynamicAutoHeightInfoBox,
    ContactBanner,
    Banners,
    MainShare,
    FacebookFrame,
    SearchForm,
  },

  computed: {
    ...sharedComputed,
  },

  data() {
    return {
      doNotShow: true,
    }
  },
}
</script>
